export default __webpack_public_path__ + "static/usyd-619537ea59a871099fc033122f15e6ce.png";